"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var FlyoutListMenuWidget_1 = require("./FlyoutListMenuWidget");
var MenuItemInfo_1 = require("./MenuItemInfo");
exports.FlyoutListMenuWidget = function (props) {
    var convertedProps = tslib_1.__assign(tslib_1.__assign({}, props), { menuItemInfos: MenuItemInfo_1.convertMenuItemInfoToGeneric(props.menuItemInfos) });
    return React.createElement(FlyoutListMenuWidget_1.GenericFlyoutListMenuWidget, convertedProps);
};
exports.FlyoutListMenuWidget.displayName = 'FlyoutListMenuWidget';
//# sourceMappingURL=FlyoutListMenuTextWidget.js.map